<template>
  <pui-input
    ref="editor"
    type="text"
    :disabled="editor.disabled"
    :value="getValue"
    @change="onValueChanged"
    @blur="onBlur"
    :textarea="editor.textarea"
  >
  </pui-input>
</template>
<script>
import TableAttributeEditorMixin from './TableAttributeEditorMixin';

export default {
  components: {},
  mixins: [TableAttributeEditorMixin],
};
</script>
